import React from 'react';

interface Option {
  label: string;
  value: string;
}

interface CustomSelectProps {
  label: string;
  id: string;
  value: string;
  onChange: (v: string) => void;
  options: Option[];
  className?: string;
}

const CustomSelect: React.FC<CustomSelectProps> = React.memo(({ label, id, value, onChange, options, className }) => (
  <div className={`display-flex flex-column ${className}`}>
    <label htmlFor={id}>{label}</label>
    <select
      id={id}
      className="form-control"
      value={value}
      onChange={e => onChange(e.target.value)}
    >
      {options.map(opt => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </div>
));

export default CustomSelect; 